import { UserModel } from 'app/models/user.model';

export const DRIVER_HOME_PATH = '/driver/home';

export function isDriverUser(user: UserModel | null | undefined): boolean {
    if (!user) {
        return false;
    }

    return user.profile_type === 'DRIVER' || user.permission_group?.profile_type === 'DRIVER';
}

export function resolveDriverHomePath(user: UserModel | null | undefined): string | null {
    if (isDriverUser(user) && !user?.is_admin) {
        return DRIVER_HOME_PATH;
    }

    return null;
}
